/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForSplitGoodsInfoForSplitVo } from './OrderInfoForSplitGoodsInfoForSplitVo';
import {
    OrderInfoForSplitGoodsInfoForSplitVoFromJSON,
    OrderInfoForSplitGoodsInfoForSplitVoFromJSONTyped,
    OrderInfoForSplitGoodsInfoForSplitVoToJSON,
    OrderInfoForSplitGoodsInfoForSplitVoToJSONTyped,
} from './OrderInfoForSplitGoodsInfoForSplitVo';

/**
 * 
 * @export
 * @interface Goods
 */
export interface Goods {
    /**
     * 商品关联的通关类目ID
     * @type {number}
     * @memberof Goods
     */
    ctmsItemId?: number;
    /**
     * 通关类目名称，按当前语言展示，与订单列表一致
     * @type {string}
     * @memberof Goods
     */
    ctmsItemName?: string;
    /**
     * 历史商品关联的SKU ID
     * @type {number}
     * @memberof Goods
     */
    skuId?: number;
    /**
     * SKU 展示编码，与数据库 SKU 主键区分。
     * @type {string}
     * @memberof Goods
     */
    skuCode?: string;
    /**
     * 历史商品英文名称
     * @type {string}
     * @memberof Goods
     */
    nameEn?: string;
    /**
     * 历史商品单价币种
     * @type {string}
     * @memberof Goods
     */
    currencyCode?: string;
    /**
     * 商品ID
     * @type {number}
     * @memberof Goods
     */
    id?: number;
    /**
     * 商品单价
     * @type {number}
     * @memberof Goods
     */
    unitPrice?: number;
    /**
     * 商品总价
     * 商品总价(韩元)
     * @type {number}
     * @memberof Goods
     */
    totalPriceKrw?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof Goods
     */
    totalPriceUsd?: number;
    /**
     * 商品链接  没有就用空字符串
     * 商品链接
     * @type {string}
     * @memberof Goods
     */
    url?: string;
    /**
     * 商品图片链接
     * @type {string}
     * @memberof Goods
     */
    imgUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof Goods
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof Goods
     */
    size?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof Goods
     */
    marketBarcode?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof Goods
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof Goods
     */
    marketOptionName?: string;
    /**
     * 市场选项ID
     * @type {string}
     * @memberof Goods
     */
    marketOptionId?: string;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof Goods
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof Goods
     */
    coHsCode?: string;
    /**
     * 是否为合包商品 0 不是，1 是  （0是基础商品，1 是合包商品）
     * 是否为合包商品
     * @type {number}
     * @memberof Goods
     */
    combined?: number;
    /**
     * 商品初始数量  分单的时候，要是分商品，那商品可用数量和初始数量都要减
     * 商品初始数量
     * @type {number}
     * @memberof Goods
     */
    initQuantity?: number;
    /**
     * 商品可用数量
     * @type {number}
     * @memberof Goods
     */
    availableQuantity?: number;
    /**
     * 是否为快递件商品：0 否，1 是
     * @type {number}
     * @memberof Goods
     */
    simple?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof Goods
     */
    code?: string;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof Goods
     */
    totalPriceCny?: number;
    /**
     * 商品构成
     * @type {number}
     * @memberof Goods
     */
    constructCount?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof Goods
     */
    trackingNumbers?: string;
    /**
     * 货位
     * @type {string}
     * @memberof Goods
     */
    locationNos?: string;
    /**
     * 基础商品列表
     * @type {Array<OrderInfoForSplitGoodsInfoForSplitVo>}
     * @memberof Goods
     */
    baseGoods?: Array<OrderInfoForSplitGoodsInfoForSplitVo>;
    /**
     * 历史SKU、规格及合包构成签名，禁止不一致商品合并。
     * @type {string}
     * @memberof Goods
     */
    structureSignature?: string;
}

/**
 * Check if a given object implements the Goods interface.
 */
export function instanceOfGoods(value: object): value is Goods {
    return true;
}

export function GoodsFromJSON(json: any): Goods {
    return GoodsFromJSONTyped(json, false);
}

export function GoodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Goods {
    if (json == null) {
        return json;
    }
    return {
        
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'ctmsItemName': json['ctmsItemName'] == null ? undefined : json['ctmsItemName'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'id': json['id'] == null ? undefined : json['id'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPriceKrw': json['totalPriceKrw'] == null ? undefined : json['totalPriceKrw'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'url': json['url'] == null ? undefined : json['url'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'code': json['code'] == null ? undefined : json['code'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'trackingNumbers': json['trackingNumbers'] == null ? undefined : json['trackingNumbers'],
        'locationNos': json['locationNos'] == null ? undefined : json['locationNos'],
        'baseGoods': json['baseGoods'] == null ? undefined : ((json['baseGoods'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoFromJSON)),
        'structureSignature': json['structureSignature'] == null ? undefined : json['structureSignature'],
    };
}

export function GoodsToJSON(json: any): Goods {
    return GoodsToJSONTyped(json, false);
}

export function GoodsToJSONTyped(value?: Goods | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ctmsItemId': value['ctmsItemId'],
        'ctmsItemName': value['ctmsItemName'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'nameEn': value['nameEn'],
        'currencyCode': value['currencyCode'],
        'id': value['id'],
        'unitPrice': value['unitPrice'],
        'totalPriceKrw': value['totalPriceKrw'],
        'totalPriceUsd': value['totalPriceUsd'],
        'url': value['url'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'combined': value['combined'],
        'initQuantity': value['initQuantity'],
        'availableQuantity': value['availableQuantity'],
        'simple': value['simple'],
        'code': value['code'],
        'totalPriceCny': value['totalPriceCny'],
        'constructCount': value['constructCount'],
        'trackingNumbers': value['trackingNumbers'],
        'locationNos': value['locationNos'],
        'baseGoods': value['baseGoods'] == null ? undefined : ((value['baseGoods'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoToJSON)),
        'structureSignature': value['structureSignature'],
    };
}

